export type DeviceName =
    | 'mobile'
    | 'tablet'
    | 'desktop'
    | 'desktop-xl'
    | 'desktop-xxl';

const deviceViewportMappings: Record<DeviceName, [number, number | undefined]> =
    {
        mobile: [0, 767],
        tablet: [768, 1023],
        desktop: [1024, undefined],
        'desktop-xl': [1250, undefined],
        'desktop-xxl': [1600, undefined]
    };

export const mapDeviceNameToViewport = (device: DeviceName) => {
    return deviceViewportMappings[device];
};
